import isClientEnv from './isClientEnv'

import subscriptionProcessingStatuses from './subscriptionProcessingStatuses'
import upgradeSubscriptionFlowSteps from './upgradeSubscriptionFlowSteps'
import upgradeSubscriptionTypes from './upgradeSubscriptionTypes'
import cosmeticsProductTypes from './cosmeticsProductTypes'
import cosmeticsCategories from './cosmeticsCategories'
import pricesWithDiscount from './pricesWithDiscount'
import discountCoupons from './discountCoupons'
import analyticsEvents from './analyticsEvents'
import paymentMethods from './paymentMethods'
import requestTokens from './requestTokens'
import deliveryStatuses from './deliveryStatuses'
import specialFlowCookies from './specialFlowCookies'
import productVisibility from './productVisibility'
import localStorageNames from './localStorageNames'
import specialFlowNames from './specialFlowNames'
import facebookPixels from './facebookPixels'
import snowplowEvents from './snowplowEvents'
import deliveryTypes from './deliveryTypes'
import productsFeed from './productsFeed'
import layoutNames from './layoutNames'
import collections from './collections'
import cookieNames from './cookieNames'
import offerNames from './offerNames'
import planNames from './planNames'
import popups from './popups'
import price from './price'

import addressVerificationOptions from './addressVerificationOptions'
import cosmeticsLinksWithTypes from './cosmeticsLinksWithTypes'
import subscriptionStatuses from './subscriptionStatuses'
import queueItemStatuses from './queueItemStatuses'
import productTypeGroups from './productTypeGroups'
import productTypeLinks from './productTypeLinks'
import resubscribeTypes from './resubscribeTypes'
import unpauseTypes from './unpauseTypes'
import authViewNames from './authViewNames'
import paymentTypes from './paymentTypes'
import mediaProps from './mediaProps'
import mediaList from './mediaList'
import gqlFeatures from './gqlFeatures'
import features from './features'
import abTests from './abTests'
import modals from './modals'
import media from './media'

import tours from './tours'

import exceptionTags from './exceptionTags'

import testIds from './testIds'

import zodiacList from './zodiacList'


export default {
  isClientEnv,

  subscriptionProcessingStatuses,
  upgradeSubscriptionFlowSteps,
  upgradeSubscriptionTypes,
  cosmeticsProductTypes,
  cosmeticsCategories,
  pricesWithDiscount,
  discountCoupons,
  analyticsEvents,
  paymentMethods,
  requestTokens,
  deliveryStatuses,
  specialFlowCookies,
  productVisibility,
  localStorageNames,
  specialFlowNames,
  facebookPixels,
  snowplowEvents,
  deliveryTypes,
  productsFeed,
  collections,
  layoutNames,
  cookieNames,
  offerNames,
  planNames,
  popups,
  price,

  addressVerificationOptions,
  cosmeticsLinksWithTypes,
  subscriptionStatuses,
  queueItemStatuses,
  productTypeGroups,
  productTypeLinks,
  resubscribeTypes,
  unpauseTypes,
  authViewNames,
  paymentTypes,
  mediaProps,
  mediaList,
  gqlFeatures,
  features,
  abTests,
  modals,
  media,
  tours,

  exceptionTags,

  testIds,

  zodiacList,
}
